import { Component, ViewChild } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { AccountService } from '../../../services/account.service';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import _ from 'lodash';
import { AccountGridResponse, Accounts, gridPageRequest, gridPagination } from '../../../model/common/common.model';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-account-list',
  standalone: true,
  imports: [SharedModule, CommonModule],
  providers: [MessageService],
  templateUrl: './account-list.component.html',
  styleUrl: './account-list.component.scss'
})
export class AccountListComponent {
  selectedAccount: Accounts[] = [];
  isActive: boolean = false;
  searchKey: any;
  AccountsMaster: Accounts[] = [];

  constructor(
    private AccountService: AccountService,
    private route: Router,
    private confirmationService: ConfirmationService,
    private messageService: MessageService
  ) { }
  recalculateLoading = false;
  @ViewChild('dt1') dt1: Table | undefined;
  Accounts: Accounts[] = [];
  start: number = 0;
  rowsPerPage: number = 5;
  gridPagination: gridPagination = {
    first: 0,
    last: 0,
    totalRecords: 0
  }

  result: AccountGridResponse = {
    account: [],
    totalRecords: 0
  }

  pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 1000,
    id: 0
  }

  ngOnInit(): void {
    document.title = 'Account List';
    this.getAccounts(this.pageRequest);
    this.searchEffect();
  }



  getAccounts(query: gridPageRequest) {
    this.AccountService.getAllAccounts(query).subscribe({
      next: data => {
        this.result = data as AccountGridResponse;
        this.Accounts = [...this.result.account];
        this.gridPagination.totalRecords = this.result.totalRecords;
        this.pageCalculation();
      },
      error: error => console.error(error)
    });
  }



  pageCalculation() {
    let last = (this.pageRequest.pageIndex * this.pageRequest.pageSize) + this.pageRequest.pageSize;
    this.gridPagination.first = (this.pageRequest.pageIndex * this.pageRequest.pageSize) + 1;
    this.gridPagination.last = last < this.result.totalRecords ? last : this.result.totalRecords;
    this.gridPagination.totalRecords = this.result.totalRecords;
  }

  createAccount() {
    this.route.navigate(['/home/createAccounts']);
  }

  editAccount(data?: any) {
    if (data) {
      this.route.navigate(['/home/createAccounts'], { queryParams: { 'accountsId': data }, skipLocationChange: true },);
    } else {
      this.route.navigate(['/home/createAccounts'], { queryParams: { 'accountsId': this.selectedAccount[0].accountsId }, skipLocationChange: true },);
    }
  }


  deleteAccount() {
    this.confirmationService.confirm({
      header: 'Are you sure?',
      message: 'Please confirm to proceed.',
      accept: () => {
        if (this.selectedAccount && this.selectedAccount.length > 0) {
          var AccountIds = _.map(this.selectedAccount, 'accountsId');
          this.AccountService.deleteAccount(AccountIds).subscribe({
            next: data => {
              this.selectedAccount = [];
              this.getAccounts(this.pageRequest);
            },
            error: error => {

            }
          });
        }

      },
      reject: () => {
      }
    });

  }

  loadAccounts(event: any) {
    this.pageRequest.pageSize = event.rows;
    this.pageRequest.pageIndex = event.first / event.rows;
    if (this.searchKey && this.searchKey.trim() !== '') {
      this.searchAccounts();
    } else {
      this.getAccounts(this.pageRequest);
    }
  }


  searchAccounts() {
    if (!this.searchKey || this.searchKey.trim() === '') {
      this.getAccounts(this.pageRequest);
      return;
    }

    this.AccountService.searchAccount(this.searchKey).subscribe({
      next: (data: any) => {

        this.result.account = Array.isArray(data) ? data : [data];
        this.gridPagination.totalRecords = this.result.account.length;

        if (this.dt1) {
          this.dt1.first = 0;
        }
      },
      error: err => console.error(err)
    });
  }




  refreshData(): void {
    if (this.dt1) {
      this.dt1.first = 0;
      this.dt1.clear();
    }
    this.searchKey = '';
    this.pageRequest.pageIndex = 0;
    this.pageRequest.pageSize = 1000;

    this.getAccounts(this.pageRequest);
  }

  formatClosingBalance(value: number | null | undefined): string {
    const num = Number(value ?? 0);
    return `₹${num.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }

  recalculateGlBalances(): void {
    this.confirmationService.confirm({
      header: 'Recalculate GL Balances',
      message: 'This will recalculate Opening Balance and Closing Balance on all posted GL transactions for every account. Continue?',
      accept: () => {
        this.recalculateLoading = true;
        this.AccountService.recalculateGlBalances().subscribe({
          next: (res: any) => {
            this.recalculateLoading = false;
            this.messageService.add({
              severity: 'success',
              summary: 'GL Balances Updated',
              detail: res?.message ?? res?.Message ?? 'Opening/closing balances recalculated successfully.'
            });
            this.getAccounts(this.pageRequest);
          },
          error: (err: any) => {
            this.recalculateLoading = false;
            this.messageService.add({
              severity: 'error',
              summary: 'Failed',
              detail: err?.error?.message ?? err?.error?.Message ?? 'Could not recalculate GL balances.'
            });
          }
        });
      }
    });
  }


  
  placeholder: string = 'Search By ';
  private messages: string[] = ['Account Code', 'Account Name', 'Account Type', 'Account Group']; 
  private messageIndex = 0;
  private charIndex = 0;


  searchEffect() {
    const base = 'Search By ';
    const typeNextChar = () => {
      if (this.charIndex <= this.messages[this.messageIndex].length) {
        this.placeholder = base + this.messages[this.messageIndex].substring(0, this.charIndex);
        this.charIndex++;
        setTimeout(typeNextChar, 150);
      } else {
        setTimeout(() => {
          this.messageIndex = (this.messageIndex + 1) % this.messages.length;
          this.charIndex = 0;
          typeNextChar();
        }, 1000);
      }
    };
    typeNextChar();
  }


}
